export default {
  subTitle: {
    en: 'Get access to over 800 designer & niche fragrances',
  },
  title: {
    en: 'Cancel skipped month',
  },
}
